import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { ReferredUsersModalPage } from './referred-users-modal.page';

const routes: Routes = [
  {
    path: '',
    component: ReferredUsersModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [ReferredUsersModalPage]
})
export class ReferredUsersModalPageModule {}
